import '../../assets/css/terms.css'

const RefundPolicy = () => {

  return (
    <div>
      <div
        className='leftContainer page_layout'
      >
        <div className='Orher_page_main_section'>
          <h1 className='profile_headings'>Refund Policy</h1>

            <>
              <p className='p2 small_para'>
                Thanks for being a patron with King Mastar WEBTECH PRIVATE LIMITED
                (referred as “King Mastar”)
                <span className='Apple-converted-space'>&nbsp; </span>. If you
                are not entirely satisfied with your subscription, we are here
                to help.
              </p>
              <p className='other_page_small_headings'>Refund</p>
              <p className='p2 small_para'>
                Once we receive your Refund request, we will inspect it and
                notify you on the status of your refund.
              </p>
              <p className='p2 small_para'>
                If your refund request is approved, we will initiate a refund to
                your credit card (or original method of payment) within 7
                working days. You will receive the credit within a certain
                amount of days, depending on your card issuer's policies.
              </p>
              <p className='p2 small_para'>
                In case of unforeseen technical glitch, King Mastar WEBTECH PRIVATE
                LIMITED would refund subscription upon reviewing the complaint.
                Final decision lies with the company.
              </p>
            </>
          </div>
        </div>
      </div>
  )
}
export default RefundPolicy
